import { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
import { FixedContainer } from '@calendly/ui/components/fixed-container'

import { isPollSelector } from 'selectors/event_type'
import { selectedSpotsSelector } from 'selectors/calendar'
import { calendarSpotsCountSelector } from 'selectors/calendars'
import { confirmSpot, spotSelectionError } from 'actions/spot'

import PollVotesWarning from './poll_votes_warning'
import ActionBar from './action_bar'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/index.js?styleId=Container";


const MIN_WARNING_SPOT_COUNT = 4

// On phone this bar is portaled out of the layout and pinned to the viewport, so the legal
// footer in components/select_date_time reads this to stack itself above the bar. Its height
// depends on the bar's contents, so publish the measured value rather than a constant.
const POLL_ACTION_BAR_HEIGHT_VAR = '--poll-action-bar-height'

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    as: FixedContainer,
    fixedWhen: useDeviceType('isPhone')
  })
})

const Footer = () => {
  const dispatch = useDispatch()
  const isPoll = useSelector(isPollSelector)
  const selectedSpots = useSelector(selectedSpotsSelector)
  const calendarSpotsCount = useSelector(calendarSpotsCountSelector)
  const [showPollVotesWarning, setShowPollVotesWarning] = useState(false)
  const isPhone = useDeviceType('isPhone')
  const containerRef = useRef(null)

  const shouldShowPollVotesWarning = selectedSpots.length === 1 && calendarSpotsCount >= MIN_WARNING_SPOT_COUNT

  useEffect(() => {
    if (!shouldShowPollVotesWarning) {
      setShowPollVotesWarning(false)
    }
  }, [shouldShowPollVotesWarning])

  useEffect(() => {
    const node = containerRef.current
    if (!isPoll || !isPhone || !node) return undefined

    const publishHeight = () => {
      document.documentElement.style.setProperty(POLL_ACTION_BAR_HEIGHT_VAR, `${node.offsetHeight}px`)
    }

    publishHeight()
    const observer = new ResizeObserver(publishHeight)
    observer.observe(node)

    return () => {
      observer.disconnect()
      document.documentElement.style.removeProperty(POLL_ACTION_BAR_HEIGHT_VAR)
    }
  }, [isPhone, isPoll])

  const next = () => {
    if (shouldShowPollVotesWarning && !showPollVotesWarning) {
      setShowPollVotesWarning(true)
      return
    }

    if (selectedSpots.length >= 1) {
      dispatch(confirmSpot(selectedSpots[0]))
    } else {
      dispatch(spotSelectionError())
    }
  }

  if (!isPoll) return null

  return (
    <Container ref={containerRef}>
      {showPollVotesWarning ? <PollVotesWarning onConfirm={next} /> : <ActionBar onConfirm={next} />}
    </Container>
  )
}

export default Footer
